// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"40":"ef024f19","80":"613bfe39","248":"c8da8ce1","354":"64fb2958","432":"c878d6d9","569":"7909161d","635":"59335548","787":"ecfa036e"}[chunkId] + ".chunk.js";
};